export const handleNumberKeyDown: React.KeyboardEventHandler<HTMLInputElement> = async (e) => {
  const $allowedKeys = ['ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Tab'];

  if ((e.ctrlKey || e.shiftKey || $allowedKeys.indexOf(e.key) >= 0) && e.key !== '+') {
    return true;
  }

  const $input = e.target as HTMLInputElement;
  const $numberKey = +e.key;

  if (!$numberKey && $numberKey !== 0) {
    e.preventDefault();
    return false;
  }

  const $maxLength = +($input.getAttribute('maxLength') || '');

  if ($maxLength && $input.value.length >= $maxLength) {
    e.preventDefault();
    return false;
  }

  return true;
};
